// @ts-nocheck
import React, { useEffect } from "react";
import { useState } from "react";
import {
  Box,
  Icon,
  Input,
  InputAdornment,
  TableSortLabel,
  Typography,
  Pagination,
  PaginationItem,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import SortArrow from "../../../assets/images/sort-arrow.svg";
import TableBody from "@mui/material/TableBody";
import { useTheme } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { ArrowBack, ArrowForward, Close, Search } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "../../event-request/EventRequests.css";
import LoadingOverlay from "../../../components/Custom/LoadingOverlay";

// icons
import { getAllOpportunitiesAction } from "../../../store/actions/opportunities";
import ViewOpportunitiesModal from "../components/ViewOpportunitiesModal";
import ViewMultipleOpportunityModal from "./ViewMultipleOpportunityModal";
import {
  convertFromUTCToGivenTimezone,
  formatAMPM,
} from "../../../utils/methods/dateAndTimeMethods";
import { dateRegex } from "../../../utils/constants/dateRegex";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import GenericTransparentBtn from "../../../components/Custom/GenericTransparentBtn";
import { inputRegex } from "../../../utils/constants/inputRegex";
import { rowsPerPageInit } from "../../../utils/constants/paginationConstants";
import { fetchEmailDataAction } from "../../../store/actions/emailRedirect";
import { onSubmitFormNoAction } from "../../../utils/methods/eventUtils";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&.rejected": {
    backgroundColor: "#ed101070",
  },
  // hide last border
  // "&:last-child td, &:last-child th": {
  //   border: 0,
  // },
}));

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.MuiPaginationItem-root": {
    color: theme.palette.common.white,
  },
  "&.Mui-selected": {
    color: theme.palette.secondary.main,
  },
}));

export const ContractorAllOpportunities = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  // Refs start...
  const initialRef = React.useRef(true);
  const tabInitialRef = React.useRef(true);
  // Refs end...

  // Selectors start...
  const {
    opportunitiesAll,
    isLoading,
    allTotalPages: totalPages,
    allCurrentPage: currentPage,
    searchString,
  } = useSelector((state) => state.opportunities);
  const { userRole } = useSelector((state) => state.auth);
  // Selectors end...

  // State variables start...
  const [rows, setRows] = React.useState([]);
  const [count, setCount] = React.useState(0);
  const [page, setPage] = React.useState(currentPage || 1);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsPerPageInit);
  const [filterParams, setFilterParams] = useState({
    sortOrder: "",
    sortField: "",
  });
  // const [order, setOrder] = useState("asc");
  const [searchStr, setSearchStr] = useState(searchString?.notResponded || "");
  const [isViewOpportunity, setIsViewOpportunity] = useState({
    status: false,
    id: null,
    opportunityId: null,
    data: null,
  });
  const [isViewMultipleOpportunity, setViewMultipleOpportunity] = useState({
    status: false,
    sessionId: "",
    eventId: "",
    data: null,
  });
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // State variables end...

  const location = useLocation();

  function getDateList(arr) {
    const set = [];
    // Guard against undefined arr — opp.positions can be undefined when a
    // recently invited contractor has an opportunity with no position resolved yet.
    (arr || []).forEach((pos) => {
      // set.push(dayjs(pos?.startDate).format("DD MMM, YYYY"));
      set.push(getUniversalDateTimeFormat({ dateTime: pos?.startDate }));
    });
    return set;
  }

  function getTimeList(arr, timezone) {
    const set = [];
    arr?.forEach((pos) => {
      if (!pos?.timeIn || !pos?.timeOut) {
        set?.push("-");
      } else {
        if (
          !dateRegex.test(pos?.timeIn?.split?.("T")?.[0]) ||
          !dateRegex.test(pos?.timeOut?.split?.("T")?.[0])
        ) {
          set.push(`TBD (${pos?.numberOfHours} hours)`);
        } else {
          set?.push(
            `${
              dateRegex.test(pos?.timeIn?.split?.("T")?.[0])
                ? formatAMPM(
                    convertFromUTCToGivenTimezone({
                      dateStr: pos?.timeIn,
                      timezone: timezone,
                    }),
                  )
                : "TBD"
            } - ${
              dateRegex.test(pos?.timeOut?.split?.("T")?.[0])
                ? formatAMPM(
                    convertFromUTCToGivenTimezone({
                      dateStr: pos?.timeOut,
                      timezone: timezone,
                    }),
                  )
                : "TBD"
            }`,
          );
        }
      }
    });

    return set;
  }

  function getBgColor(status) {
    switch (status?.toLowerCase()) {
      case "applied":
        return "#0774508a";
      case "not responed":
        return "transparent";
      case "partially responded":
        return "#cda80c99";
      default:
        return "transparent";
    }
  }

  // NOTE: have to keep this useeffect and other one, this will use for the old data we send through email and for the next one we'll fetch the data from redis id
  React.useEffect(() => {
    if (location?.state?.positions?.length > 1) {
      setViewMultipleOpportunity({
        status: true,
        sessionId: location?.state?.sessionId,
        eventId: location?.state?.eventId,
        data: location?.state,
      });
    } else if (location?.state?.id) {
      setIsViewOpportunity({
        status: true,
        id: location?.state?.id,
        opportunityId: location?.state?.opportunityId,
        data: location?.state,
      });
    }
    window.history.replaceState({}, "");

    return () => {
      setIsViewOpportunity({
        status: false,
        id: null,
        opportunityId: null,
        data: null,
      });
      setViewMultipleOpportunity({
        status: false,
        sessionId: "",
        eventId: "",
        data: null,
      });
    };
  }, [location?.state?.positions]);

  // Email-link deep-link (no Redis). `getEmailLinkData` on the new backend
  // resolves the `event` from Mongo and REQUIRES `eventId`; the legacy Redis
  // blob keyed by `dataId` no longer exists. We only hit the endpoint when an
  // `eventId` is present (forwarding the legacy `redisId` as `dataId` for
  // backward-compat). Legacy links carrying only `redisId` can't be resolved,
  // so we degrade gracefully (clear the stale state, no 404 request, no loop)
  // and let the opportunities list render. The inline-state branch above
  // (location.state.id / .positions) still handles the new-style links.
  useEffect(() => {
    const eventId = location?.state?.eventId;
    const redisId = location?.state?.redisId;
    if (!eventId) {
      if (redisId) window.history.replaceState({}, "");
      return;
    }
    dispatch(
      fetchEmailDataAction({
        payload: {
          params: {
            eventId,
            ...(redisId ? { dataId: redisId } : {}),
          },
        },
        successCallback: (res) => {
          if (res?.data?.data?.[0]?.positions?.length > 1) {
            setViewMultipleOpportunity({
              status: true,
              sessionId: res?.data?.data?.[0]?.sessionId,
              eventId: res?.data?.data?.[0]?.eventId,
              data: res?.data?.data?.[0],
            });
          } else {
            setIsViewOpportunity({
              status: true,
              id: res?.data?.data?.[0]?.positions?.[0]?._id,
              opportunityId:
                res?.data?.data?.[0]?.positions?.[0]?.opportunityId,
              data: res?.data?.data?.[0],
            });
          }
          window.history.replaceState({}, "");
        },
      }),
    );

    return () => {
      setIsViewOpportunity({
        status: false,
        id: null,
        opportunityId: null,
        data: null,
      });
      setViewMultipleOpportunity({
        status: false,
        sessionId: "",
        eventId: "",
        data: null,
      });
    };
  }, [location?.state?.eventId, location?.state?.redisId]);

  // useEffect(() => {
  //
  // }, [location?.state?.redisId])

  React.useEffect(() => {
    if (opportunitiesAll?.length > 0) return;
    fetchDataHandler({});
    // dispatch(
    //   getNROpportunitiesAction({
    //     payload: {
    //       params: {
    //         page,
    //         limit: rowsPerPage,
    //       },
    //     },
    //   }),
    // );
  }, []);

  React.useEffect(() => {
    if (initialRef.current) {
      return;
    }
    fetchDataHandler({});
  }, [filterParams, page, rowsPerPage, count]);

  React.useEffect(() => {
    if (initialRef.current) {
      initialRef.current = false;
      return;
    }
    const debounce = setTimeout(() => {
      if (page === 1) {
        fetchDataHandler({});
      } else {
        setPage(1);
      }
      // if (!searchStr || searchStr === "") {
      //   setRows(opportunitiesNR);
      //   setPage(1);
      // } else {
      //   if (opportunitiesNR.length === 0) {
      //     setRows([]);
      //   } else {
      //     const newRows = opportunitiesNR.filter(
      //       (item) =>
      //         item?.positionName
      //           ?.toLowerCase()
      //           .includes(searchStr.toLowerCase()) ||
      //         item?.eventName
      //           ?.toLowerCase()
      //           .includes(searchStr.toLowerCase()) ||
      //         item?.venue?.toLowerCase().includes(searchStr.toLowerCase()),
      //     );
      //     setRows(newRows);
      //   }
      // }
    }, [300]);

    return () => {
      clearTimeout(debounce);
    };
  }, [searchStr]);

  React.useEffect(() => {
    setRows(opportunitiesAll);
  }, [opportunitiesAll]);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const fetchDataHandler = async ({ params }) => {
    // Escolhe endpoint conforme a rota:
    //  /opportunities/declined  → getDeclinedOpportunities
    //  /opportunities/applied   → getAppliedOpportunities
    //  /opportunities[/...]     → getPendingAppliedOpportunities (default)
    const path = (location?.pathname || "").toLowerCase();
    const endpoint = path.includes("/declined")
      ? "getDeclinedOpportunities"
      : path.includes("/applied")
        ? "getAppliedOpportunities"
        : "getPendingAppliedOpportunities";
    dispatch(
      getAllOpportunitiesAction({
        payload: {
          endpoint,
          params: {
            page,
            limit: rowsPerPage,
            search: searchStr,
            ...(filterParams || {}),
            ...(params || {}),
          },
        },
      }),
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // if (!searchStr || searchStr === "") {
    //   setRows(opportunitiesNR);
    //   setPage(newPage);
    // } else {
    //   const newRows = opportunitiesNR.map((item) => {
    //     return (
    //       item.positionName.toLowerCase().includes(searchStr.toLowerCase()) ||
    //       item.eventName.toLowerCase().includes(searchStr.toLowerCase()) ||
    //       item.venue.toLowerCase().includes(searchStr.toLowerCase())
    //     );
    //   });
    //   setRows(newRows);
    //   setPage(newPage);
    // }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleSortRequest = ({ cb, field }) => {
    const newOrder = filterParams?.sortOrder === "asc" ? "desc" : "asc";
    setFilterParams((filterParams) => {
      return {
        ...filterParams,
        sortOrder: newOrder,
        sortField: field,
      };
    });
    // const sortedRows = [...rows].sort((a, b) => {
    //   const aValue = cb ? cb({ row: a }) : a.name;
    //   const bValue = cb ? cb({ row: b }) : b.name;

    //   if (newOrder === "asc") {
    //     if (aValue < bValue) {
    //       return -1;
    //     }
    //     if (aValue > bValue) {
    //       return 1;
    //     }
    //     return 0;
    //   } else {
    //     if (aValue < bValue) {
    //       return 1;
    //     }
    //     if (aValue > bValue) {
    //       return -1;
    //     }
    //     return 0;
    //   }
    // });
    // setRows(sortedRows);
    // setOrder(newOrder);
  };

  const handleSearch = (e) => {
    const value = e?.target?.value?.replace(inputRegex, "");
    setSearchStr(value);
  };

  return (
    <>
      <Box
        sx={{
          padding: "20px 40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "@media (max-width: 600px)": {
            flexDirection: "column",
            padding: "20px 20px",
          },
        }}
      >
        <Typography
          variant={isSmallScreen ? "h3" : "h1"}
          sx={{
            "@media (max-width: 600px)": {
              marginBottom: "15px",
            },
          }}
        >
          Opportunities
        </Typography>
        <form autoComplete="off" onSubmit={onSubmitFormNoAction}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              "& .MuiInputBase-root": {
                border: "1px solid #FFF !important",
                background: "rgba(0, 0, 0, 0.01) !important",
                boxShadow:
                  "0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important",
                borderRadius: "8px",
                padding: "5px 24px 5px 16px",
                "&:before": {
                  content: "none",
                },
                "&:after": {
                  content: "none",
                },
                "& svg": {
                  color: "#ffffff",
                },
                "& input": {
                  color: "#ffffff",
                },
              },
            }}
          >
            <Input
              id="input-with-icon-adornment"
              onChange={handleSearch}
              value={searchStr}
              placeholder="Search here"
              // startAdornment={
              //   <InputAdornment position="start">
              //     <Search />
              //   </InputAdornment>
              // }
              endAdornment={
                <InputAdornment position="start">
                  {!searchStr ? (
                    <Search
                      sx={{
                        fontSize: "1.25rem",
                        // marginRight: "0.7rem"
                      }}
                    />
                  ) : (
                    <GenericTransparentBtn
                      onClick={() => {
                        setSearchStr("");
                      }}
                      style={{
                        background: "grey",
                        padding: "0.10rem",
                        borderRadius: "50%",
                        onHover: {
                          background: "grey",
                          padding: "0.10rem",
                        },
                      }}
                    >
                      <Close
                        sx={{
                          fontSize: "1rem",
                          // marginRight: "0.7rem"
                        }}
                      />
                    </GenericTransparentBtn>
                  )}
                </InputAdornment>
              }
              sx={{
                paddingLeft: "1rem !important",
                border: "1px solid #FFF !important",
                "@media (max-width: 1000px)": {
                  flexGrow: "1",
                  // width: "70%"
                },
              }}
            />
          </Box>
        </form>
      </Box>
      <Box>
        {isLoading ? (
          <LoadingOverlay open={isLoading} />
        ) : (
          <Box>
            <TableContainer
              className="custom-scroll-design"
              sx={{
                maxWidth: "100%",
                ...(isSmallScreen
                  ? {
                      minHeight: "calc(100vh - 323px)",
                    }
                  : {
                      height: "88vh",
                    }),
                overscrollBehavior: "auto",
              }}
            >
              <Table sx={{}} aria-label="sticky table" stickyHeader>
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        backgroundColor: "#D175B6 !important",
                        padding: "2px 15px",
                        fontSize: "20px",
                        color: "#ffffff",
                        borderColor: "#D175B6",
                        "& span": {
                          color: "#ffffff !important",
                        },
                      },
                      "& th:not(:last-child)": {
                        paddingRight: "0 !important",
                      },
                    }}
                  >
                    <StyledTableCell
                      sx={{
                        padding: "2px 0 2px 0",
                      }}
                      className="no-wrap"
                    >
                      <TableSortLabel
                        sx={{
                          padding: "2px 0 2px 10px",
                        }}
                        active={true}
                        direction={
                          filterParams?.sortField === "opportunityStatus"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.positionName?.toLowerCase();
                            },
                            field: "opportunityStatus",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Status
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell sx={{ minWidth: "14rem" }}>
                      <TableSortLabel
                        sx={{
                          padding: "2px 15px 2px 0",
                        }}
                        active={true}
                        direction={
                          filterParams?.sortField === "positionName"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.positionName?.toLowerCase();
                            },
                            field: "positionName",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Position Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell className="no-wrap">
                      <TableSortLabel
                        active={true}
                        direction={
                          filterParams?.sortField === "eventStart"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.sessionStart;
                            },
                            field: "eventStart",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Start Date
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell className="no-wrap">
                      {/* <TableSortLabel */}
                      {/*   active={true} */}
                      {/*   direction={filterParams?.sortOrder} */}
                      {/*   onClick={() => */}
                      {/*     handleSortRequest({ */}
                      {/*       cb: ({ row }) => { */}
                      {/*         return row?.sessionEnd; */}
                      {/*       }, */}
                      {/*       field: "eventEnd", */}
                      {/*     }) */}
                      {/*   } */}
                      {/*   IconComponent={(props) => ( */}
                      {/*     <IconButton {...props}> */}
                      {/*       <Icon>{<img src={SortArrow} />}</Icon> */}
                      {/*     </IconButton> */}
                      {/*   )} */}
                      {/* > */}
                      {/*   End Date */}
                      {/* </TableSortLabel> */}
                      Time In/Out
                    </StyledTableCell>
                    <StyledTableCell>
                      <TableSortLabel
                        active={true}
                        direction={
                          filterParams?.sortField === "venue"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.venue?.toLowerCase();
                            },
                            field: "venue",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Venue
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell>
                      <TableSortLabel
                        active={true}
                        direction={
                          filterParams?.sortField === "eventName"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.eventName?.toLowerCase();
                            },
                            field: "eventName",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Event
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell>
                      <TableSortLabel
                        active={true}
                        direction={
                          filterParams?.sortField === "sessionName"
                            ? filterParams?.sortOrder
                            : "desc"
                        }
                        onClick={() =>
                          handleSortRequest({
                            cb: ({ row }) => {
                              return row?.sessionName?.toLowerCase();
                            },
                            field: "sessionName",
                          })
                        }
                        IconComponent={(props) => (
                          <IconButton {...props}>
                            <Icon>{<img src={SortArrow} />}</Icon>
                          </IconButton>
                        )}
                      >
                        Session
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  sx={{
                    "& td": {
                      borderColor: "#D175B6",
                      color: "#ffffff",
                      "& td": {},
                    },
                    "& td:not(:last-child)": {
                      paddingRight: "0 !important",
                    },
                  }}
                >
                  {rows?.length === 0 ? (
                    <StyledTableRow
                    // key={index}
                    // className={row?.isRejected ? "rejected" : ""}
                    >
                      <StyledTableCell colSpan={12}>
                        <Typography
                          sx={{
                            textAlign: "left",
                          }}
                        >
                          No records
                          {/* Position Name */}
                        </Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : (
                    rows?.map((item, index) => {
                      const row = { ...item };
                      const totalPositions = row?.positions?.length;
                      row.venue = row?.sessionVenue ?? row?.venue;
                      row.venueAddressLine1 =
                        row?.sessionVenueAddressLine1 ?? row?.venueAddressLine1;
                      row.venueAddressLine2 =
                        row?.sessionVenueAddressLine2 ?? row?.venueAddressLine2;
                      row.venueCity = row?.sessionVenueCity ?? row?.venueCity;
                      row.venueState =
                        row?.sessionVenueState ?? row?.venueState;
                      row.venueZipCode =
                        row?.sessionVenueZipCode ?? row?.venueZipCode;
                      row.lat = row?.sessionLat ?? row?.lat;
                      row.long = row?.sessionLong ?? row?.long;
                      return (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: `${getBgColor(
                              row?.opportunityStatus?.toLowerCase(),
                            )} !important`,
                          }}
                          // className={row?.isRejected ? "rejected" : ""}
                        >
                          <StyledTableCell
                            sx={{
                              maxWidth: "18rem",
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                // marginLeft: "40px",
                                "& a": {
                                  lineHeight: "0",
                                },
                                "& img": {},
                              }}
                            >
                              {row?.opportunityStatus || "N/A"}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{
                              maxWidth: "18rem",
                            }}
                          >
                            <Typography
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                // marginLeft: "40px",
                                "& a": {
                                  lineHeight: "0",
                                },
                                "& img": {},
                              }}
                            >
                              {row?.positions?.slice(0, 5)?.map((pos, i) => (
                                <Typography key={i}>
                                  {pos?.positionOrder
                                    ? `${pos?.positionName} - ${pos?.positionOrder}`
                                    : pos?.positionName}
                                </Typography>
                              ))}
                              {totalPositions > 5 && (
                                <Typography>
                                  ...{totalPositions - 5} more position
                                  {totalPositions - 5 > 1 ? "s" : ""}
                                </Typography>
                              )}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell>
                            {getDateList(row?.positions)
                              ?.slice(0, 5)
                              ?.map((date, i) => {
                                return <Typography key={i}>{date}</Typography>;
                              })}
                            {totalPositions > 5 && (
                              <Typography>
                                ...{totalPositions - 5} more position
                                {totalPositions - 5 > 1 ? "s" : ""}
                              </Typography>
                            )}
                          </StyledTableCell>
                          <StyledTableCell>
                            <Typography>
                              {getTimeList(row?.positions, row?.eventTimezone)
                                ?.slice(0, 5)
                                ?.map((time, i) => {
                                  return (
                                    <Typography
                                      paddingLeft={
                                        time === "-" ? "4rem" : "0rem"
                                      }
                                      key={i}
                                    >
                                      {time}
                                    </Typography>
                                  );
                                })}
                              {totalPositions > 5 && (
                                <Typography>
                                  ...{totalPositions - 5} more position
                                  {totalPositions - 5 > 1 ? "s" : ""}
                                </Typography>
                              )}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{
                              maxWidth: "14rem",
                            }}
                          >
                            <Typography
                              sx={{
                                wordBreak: "break-all",
                              }}
                            >
                              {`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                              {/* <LineClamp
                                text={`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                                maxLines={1}
                              /> */}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{
                              maxWidth: "14rem",
                            }}
                          >
                            <Typography
                              sx={{
                                wordBreak: "break-all",
                              }}
                            >
                              {row?.eventName}
                            </Typography>
                            {/* <LineClamp
                              text={`${row?.eventName}`}
                              maxLines={1}
                            /> */}
                          </StyledTableCell>
                          <StyledTableCell
                            sx={{
                              maxWidth: "14rem",
                            }}
                          >
                            <Typography
                              sx={{
                                wordBreak: "break-all",
                              }}
                            >
                              {`${row?.sessionName}`}
                            </Typography>
                            {/* <LineClamp
                              text={`${row?.sessionName}`}
                              maxLines={1}
                            /> */}
                          </StyledTableCell>
                          <StyledTableCell>
                            <Typography>
                              {row?.reponse?.pending ? (
                                row?.clientDetail?.firstName +
                                " " +
                                row?.clientDetail?.lastName
                              ) : (
                                <span
                                  className="assign_client no-wrap"
                                  onClick={() => {
                                    if (row?.positions?.length > 1) {
                                      setViewMultipleOpportunity({
                                        status: true,
                                        sessionId: row?.sessionId,
                                        eventId: row?.eventId,
                                        data: row,
                                      });
                                    } else {
                                      setIsViewOpportunity({
                                        id: row?.positions?.[0]?.id,
                                        opportunityId:
                                          row?.positions?.[0]?.opportunityId,
                                        status: true,
                                        data: row,
                                      });
                                    }
                                  }}
                                >
                                  View Opportunity
                                </span>
                              )}
                            </Typography>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                "& td": {
                  display: "block",
                },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "black",
                borderRadius: "0px 0px 15px 15px",
                borderTop: "1px solid #D175B6",
              }}
            >
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handleChangePage}
                siblingCount={isSmallScreen ? 0 : 1}
                renderItem={(item) => (
                  <StyledPaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                  />
                )}
              />
            </Box>
          </Box>
        )}
      </Box>

      {isViewOpportunity?.status && (
        <ViewOpportunitiesModal
          open={isViewOpportunity?.status}
          setOpen={setIsViewOpportunity}
          applied={false}
          id={isViewOpportunity.id}
          opportunityId={isViewOpportunity.opportunityId}
          data={isViewOpportunity.data}
          setCount={setCount}
        />
      )}

      {isViewMultipleOpportunity?.status && (
        <ViewMultipleOpportunityModal
          open={isViewMultipleOpportunity?.status}
          handleClose={() => {
            setViewMultipleOpportunity((prev) => {
              return {
                ...prev,
                status: false,
              };
            });
          }}
          showButtons={true}
          rowData={isViewMultipleOpportunity?.data}
          setCount={setCount}
        />
      )}
    </>
  );
};